import React, { useState, useEffect } from 'react'
import Tabs from '../../api/components-examples/Tabs'
import CBreadCrumb from '../BreadCrumb/index.js'
import FlipSwitch from '../../api/components-examples/AppDetail/FlipSwitch'
import PopUp from '../../api/components-examples/PopUP'
import WaitingLoaders from '../Loaders/WaitingLoaders.jsx'
import { getCSubscripedPlanName, manageOrgChoice } from '../../api/components-examples/utils/commonUtilityFunctions'
import { getCurrentContextuserIdDetails } from '../../api/components-examples/Admin/AccountUtility'
import { getPaymentProductId } from './projectHelpers'
import ProjectsLearn from './ProjectsLearn'
import ProjectsBuild from './ProjectsBuild'
import ProjectCreation from './ProjectCreation'

/**
 * Determines if a flow/practice card is locked for the current user's subscription.
 */
export const isLocked = (practice, subscription, flowGroups) => {
    const type = practice.learn === true ? "Learn" : "Build"
    const subscriptionPlan =
        subscription && !subscription.isLoading && subscription.subscribedProduct && subscription.subscribedProduct.name
            ? subscription.subscribedProduct.name
            : 'NO_PLAN'

    const addOnProducts =
        subscription && !subscription.isLoading && subscription.addOnProducts ? subscription.addOnProducts : []

    if (type === 'Build') {
        if (
            subscriptionPlan.toUpperCase() === 'PROFESSIONAL' &&
            practice &&
            practice.plan &&
            practice.plan.includes(subscriptionPlan)
        ) {
            return false
        } else if (
            subscriptionPlan.toUpperCase() !== 'PROFESSIONAL' &&
            practice &&
            practice.plan &&
            practice.plan.includes(subscriptionPlan)
        ) {
            return false
        } else {
            return true
        }
    } else {
        const productId = getPaymentProductId(practice, flowGroups);
        if (!productId) return false;
        if (addOnProducts && addOnProducts.includes(productId)) {
            return false
        } else {
            return true
        }
    }
}

const ProjectMain = ({
    data,
    tabView,
    flowGroups,
    theme,
    dispatch,
    createRecord,
    projectCreationError,
    updateProjectCreationError,
    checkToProject,
    navigateTo,
    myProfile,
    isSubscriptionCheck,
    buyCourse,
    isLoadingUPlan,
    setFlow,
    cancelProjectCreation,
    getAvailableUserRoles,
    fetchAllgroups,
    uPCreation,
    projectCreated,
    formDialogue,
    groupLoading,
    closes,
    myUserAccountInfo,
    createProject,
    inviteUsertoProject,
    addProjectToGroup,
    wGroupCreated,
    projectFlowInfoKey,
    isAddedDone,
    isFlowActive,
    RgroupId,
    FlowTypeKey,
    showBuyCourse,
    hideShowBuyCourse,
    showBuyGroupInfo,
    checkIsAddIntrestedAddons,
    refreshGroups
}) => {

    const capitalizeFirstLetter = (string) => {
        try {
            return string.charAt(0).toUpperCase() + string.slice(1);
        } catch (error) { }
    };

    const [learnProjects, setLearnProjects] = useState([])
    const [buildProjects, setBuildProjects] = useState([])
    const [active, setActive] = useState(capitalizeFirstLetter(FlowTypeKey))

    const [projectPopup, setProjectPopup] = React.useState(false)
    const [upCreate, setupCreate] = React.useState(false)
    const [flowTitle, setFlowTitle] = React.useState(null)
    const [flowDescrption, setDescription] = React.useState(null)
    const [currenItem, setCurrenItem] = React.useState([])
    const [flowId, setFlowId] = React.useState(null)
    const [isBuild, setIsBuild] = React.useState(true)
    const [showAvailable, setShowAvailable] = useState(false)
    const [buyIsLoading, setBuyIsLoading] = React.useState(false)

    const handleSwitch = value => {
        setShowAvailable(value)
    }

    const currentAvailedPlan = getCSubscripedPlanName(isSubscriptionCheck)

    const getFilteredAndSortedGroupKeys = (groups, projects, tabType) => {
        const keys = Object.entries(groups)
            .map(([key, group]) => ({ ...group, id: key }))
            .filter(group => {
                if (tabType === 'Learn') {
                    return group.type === 'learn' || !group.type
                } else {
                    return group.type === 'build' || !group.type
                }
            })
            .filter(group => {
                if (group.plans && group.plans.length > 0) {
                    const currentPlan = (currentAvailedPlan || 'NO_PLAN').toUpperCase()
                    return group.plans.some(p => p.toUpperCase() === currentPlan)
                }
                return true
            })
            .sort((a, b) => (a.sequence || 0) - (b.sequence || 0))
            .map(g => g.id)

        const orphanProjects = (projects || []).filter(p => !p.group_id || !groups[p.group_id])
        if (orphanProjects.length > 0) {
            const hasLearnOrphans = orphanProjects.some(p => p.type === 'learn' || p.learn === true)
            if (hasLearnOrphans && !keys.includes('default_learn') && groups['default_learn']) {
                keys.push('default_learn')
            }

            const hasBuildOrphans = orphanProjects.some(p => p.type === 'build' || p.learn === false)
            if (hasBuildOrphans && !keys.includes('default_build') && groups['default_build']) {
                keys.push('default_build')
            }
        }
        return keys
    }

    const filteredLearnGroupKeys = getFilteredAndSortedGroupKeys(flowGroups, learnProjects, 'Learn')
    const filteredBuildGroupKeys = getFilteredAndSortedGroupKeys(flowGroups, buildProjects, 'Build')

    const current_logged_user = getCurrentContextuserIdDetails(myUserAccountInfo.current_logged_user)

    useEffect(() => {
        if (FlowTypeKey) {
            setActive(capitalizeFirstLetter(FlowTypeKey))
        }
    }, [FlowTypeKey])

    useEffect(() => {
        if (isFlowActive) {
            setActive(isFlowActive)
        }
    }, [])

    useEffect(() => {
        if (data && data.length !== 0 && !projectPopup) {
            const learn = data.filter(p => p.type === 'learn' || p.learn === true)
            const blankProject = data.find(p => p.flow_id === 'blank_project')
            const build = data.filter(p => (p.type === 'build' || p.learn === false) && p.flow_id !== 'blank_project')
            const buildWithBlank = blankProject ? [...build, blankProject] : build

            setLearnProjects(learn.filter(practice => !practice.plan || practice.plan.length > 0))
            setBuildProjects(buildWithBlank.filter(practice => !practice.plan || practice.plan.length > 0))
        }
    }, [data, active])

    const checkoutLearnGroup = key => {
        navigateTo(`/projects/flows/learn/${key}`)
        checkIsAddIntrestedAddons(flowGroups, true)
    }

    const checkoutBuildGroup = key => {
        navigateTo(`/projects/flows/build/${key}`)
        checkIsAddIntrestedAddons(flowGroups, true)
    }

    const backFromProject = () => {
        if (RgroupId) {
            navigateTo(`/projects/flows/${active.toLowerCase()}`)
        } else {
            cancelProjectCreation()
        }
    }

    const openProjectPopup = (value, label, id, description, card, isBuild) => {
        setFlow(value)
        setFlowId(id)
        setFlowTitle(label)
        setProjectPopup(true)
        closes()
        setupCreate(true)
        setDescription(description)
        setCurrenItem(card)
        setIsBuild(isBuild)
    }

    const addInLStorage = value => {
        manageOrgChoice(window.localStorage.OrgChoice, current_logged_user.orgId, 'HubFLow', value)
    }

    const getIsLocked = practice => {
        return isLocked(practice, isSubscriptionCheck, flowGroups)
    }

    const getBreadCrumb = isGroup => {
        let bArray = [
            {
                title: 'Organizations',
                path: null,
                dispatch: null,
                active: false,
                func: () => navigateTo('/organizations')
            },
            {
                title: getCSubscripedPlanName(isSubscriptionCheck) === 'LEARNER' ? 'Your Courses' : 'My Projects',
                path: null,
                dispatch: null,
                active: false,
                func: () => navigateTo('/projects')
            }
        ]

        if (isGroup !== null) {
            bArray.push(
                {
                    title: `${active} Flows`,
                    path: null,
                    dispatch: null,
                    active: false,
                    func: () => {
                        navigateTo(`/projects/flows/${capitalizeFirstLetter(active)}`)
                    }
                },
                {
                    title: flowGroups[RgroupId] && flowGroups[RgroupId].title,
                    path: null,
                    dispatch: null,
                    active: true,
                    func: null
                }
            )
        } else {
            bArray.push({
                title: `${active} Flows`,
                path: null,
                dispatch: null,
                active: true,
                func: () => null
            })
        }

        return bArray
    }

    const tabData = isSubscriptionCheck &&
        !isSubscriptionCheck.isLoading ? [
        currentAvailedPlan.toUpperCase() === 'LEARNER' &&
        {
            name: 'Learn Flows',
            id: 'Learn',
            icon: 'LEARN_FLOW',
            onClickTab: value => {
                navigateTo(`/projects/flows/learn`)
                addInLStorage(value)
            },
            component: (
                <ProjectsLearn
                    RgroupId={RgroupId}
                    checkoutLearnGroup={checkoutLearnGroup}
                    checkoutBuildGroup={checkoutBuildGroup}
                    data={learnProjects}
                    openProjectPopup={openProjectPopup}
                    tabView={tabView}
                    flowGroups={flowGroups}
                    fetchAllgroups={fetchAllgroups}
                    getIsLocked={getIsLocked}
                    showAvailable={showAvailable}
                    backs={backFromProject}
                    breadcrumb={getBreadCrumb(RgroupId)}
                    filteredGroupKeys={filteredLearnGroupKeys}
                />
            )
        },
        currentAvailedPlan.toUpperCase() !== 'LEARNER' &&
        {
            name: 'Build Flows',
            id: 'Build',
            icon: 'BUILD_FLOW',
            onClickTab: value => {
                navigateTo(`/projects/flows/build`)
                addInLStorage(value)
            },
            component: (
                <ProjectsBuild
                    data={buildProjects}
                    RgroupId={RgroupId}
                    checkoutBuildGroup={checkoutBuildGroup}
                    checkoutLearnGroup={checkoutLearnGroup}
                    openProjectPopup={openProjectPopup}
                    tabView={tabView}
                    flowGroups={flowGroups}
                    fetchAllgroups={fetchAllgroups}
                    getIsLocked={getIsLocked}
                    showAvailable={showAvailable}
                    backs={backFromProject}
                    breadcrumb={getBreadCrumb(RgroupId)}
                    filteredGroupKeys={filteredBuildGroupKeys}
                />
            )
        }
    ]
        : []

    const createCheckoutSession = (showBuyGroupInfo) => {
        const url = `${window.REACT_APP_SELF_URL}/projects/flows/${active.toLowerCase()}/${RgroupId}`
        setBuyIsLoading(true)
        buyCourse(getPaymentProductId(showBuyGroupInfo), url, url)
    }

    return (
        <div className="em-row">
            {myProfile &&
                myProfile.roles === 'owner' &&
                showBuyCourse &&
                isSubscriptionCheck &&
                !isSubscriptionCheck.isLoading &&
                !fetchAllgroups.isLoading &&
                data.length > 0 &&
                RgroupId &&
                showBuyGroupInfo &&
                showBuyGroupInfo['key'] &&
                RgroupId === showBuyGroupInfo['key'] &&
                <PopUp
                    className={'buyNow_purchase'}
                    width={'590px'}
                    bottomButton={false}
                    bottomButtonCancel={false}
                    onCancel={hideShowBuyCourse}
                >
                    {buyIsLoading === true && (<WaitingLoaders show={true} size={90} position='absolute' />)}
                    <div className={'em-row'}>
                        <div className="em-buyCourse-parent">
                            <div className="em-buycourse-img">
                                <img src={require('../../images/buyNowpurchase.png')} />
                            </div>
                            <div className="em-buycourse-description">
                                <span className="des_1"><b>{showBuyGroupInfo['title']}?</b></span>
                                <span className="des_2">
                                    <ul>
                                        <li>Modules: {showBuyGroupInfo['modules']}</li>
                                        <li>Hours : {showBuyGroupInfo['hours']}</li>
                                    </ul>
                                </span>
                                <span className="des_2">You're just one step away from transforming your skills! Secure your place and start right away.</span>

                                <span className="des_3">
                                    <button className={'em-btn -p-t-buy'} onClick={() => createCheckoutSession(showBuyGroupInfo)}>
                                        Proceed to Buy
                                    </button>
                                </span>

                                <span className="des_4">
                                    Note: If you have already purchased this course please refresh this page
                                </span>
                            </div>
                        </div>
                    </div>
                </PopUp>
            }
            {projectPopup === true && (
                <ProjectCreation
                    flowId={flowId}
                    theme={theme}
                    dispatch={dispatch}
                    flowDescrption={flowDescrption}
                    SelectedFlow={flowTitle}
                    createRecord={createRecord}
                    setProjectPopup={() => {
                        setProjectPopup(false)
                        setupCreate(false)
                    }}
                    currenItem={currenItem}
                    navigateTo={navigateTo}
                    myProfile={myProfile}
                    isBuild={isBuild}
                    isSubscriptionCheck={isSubscriptionCheck}
                    buyCourse={buyCourse}
                    isLoadingUPlan={isLoadingUPlan}
                    RgroupId={RgroupId}
                    getAvailableUserRoles={getAvailableUserRoles}
                    fetchAllgroups={fetchAllgroups}
                    uPCreation={uPCreation}
                    upCreate={upCreate}
                    projectCreated={projectCreated}
                    formDialogue={formDialogue}
                    groupLoading={groupLoading}
                    createProject={createProject}
                    inviteUsertoProject={inviteUsertoProject}
                    addProjectToGroup={addProjectToGroup}
                    flowGroups={flowGroups}
                    wGroupCreated={wGroupCreated}
                    getIsLocked={getIsLocked}
                    isAddedDone={isAddedDone}
                    refreshGroups={refreshGroups}
                    projectCreationError={projectCreationError}
                    updateProjectCreationError={updateProjectCreationError}
                    checkToProject={checkToProject}
                />
            )}

            <div className="em-row em-project-group">
                <CBreadCrumb bArray={getBreadCrumb(RgroupId).slice(0, -1)} />
            </div>

            {isSubscriptionCheck && isSubscriptionCheck.isLoading === true ? (
                <div className="em-row locenter">
                    <WaitingLoaders show={true} size={90} position='relative' />
                </div>
            ) : (
                <div className="em-row">
                    {(buildProjects && buildProjects.length !== 0 || learnProjects && learnProjects.length !== 0) && !fetchAllgroups.isLoading && currentAvailedPlan && currentAvailedPlan.toUpperCase() === 'LEARNER' && (
                        <div className={`pr-switch-avail ${active === 'Build' ? 'build' : ''}`}>
                            <FlipSwitch handleHideErrorIter={handleSwitch} label="Available" graph={true}></FlipSwitch>
                        </div>
                    )}
                    <Tabs
                        tabTitle={true}
                        tabData={tabData}
                        active={active}
                        tabWidth={'fit-content'}
                        key={projectFlowInfoKey}
                        RgroupId={RgroupId}
                    />
                </div>
            )}
        </div>
    )
}

export default ProjectMain
